// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RemoveRoutes_controlsRow__7GBbW {
  display: flex;
  align-items: center;
  gap: 16px;
}

.RemoveRoutes_bulkActions__dwHir {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* кнопки */
.RemoveRoutes_selectAllBtn__6Ua9l,
.RemoveRoutes_deleteSelectedBtn__2Kwlf {
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  border: 1px solid #cbd3e1;
  background: #f9fafc;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.RemoveRoutes_selectAllBtn__6Ua9l:hover:not(:disabled),
.RemoveRoutes_deleteSelectedBtn__2Kwlf:hover:not(:disabled) {
  background: #e8eaf6;
}

.RemoveRoutes_deleteSelectedBtn__2Kwlf {
  border-color: #e53935;
  background: #e53935;
  color: #fff;
}

.RemoveRoutes_deleteSelectedBtn__2Kwlf:hover:not(:disabled) {
  background: #c62828;
}

.RemoveRoutes_selectAllBtn__6Ua9l:disabled,
.RemoveRoutes_deleteSelectedBtn__2Kwlf:disabled {
  opacity: 0.5;
  cursor: default;
}

/* состояния */
.RemoveRoutes_stateText__tyJ9F {
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  color: #555;
}

/* карточки */
.RemoveRoutes_cardsWrapper__VMgiI {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

.RemoveRoutes_card__zfM3I {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.RemoveRoutes_card__zfM3I:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}

.RemoveRoutes_selected__ttwhb {
  border: 2px solid #3f51b5;
  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
}

/* верхняя строка: заголовок + чекбокс */
.RemoveRoutes_topRow__dJC-\\+ {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.RemoveRoutes_header__q2ONo h3 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
}

.RemoveRoutes_dateLabel__patTs {
  font-size: 12px;
  color: #757575;
}

/* чекбокс */
.RemoveRoutes_checkboxWrap__Z8HxQ {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.RemoveRoutes_checkboxWrap__Z8HxQ input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.RemoveRoutes_checkboxFake__zPl4Y {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid #cbd3e1;
  background: #fff;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.RemoveRoutes_checkboxWrap__Z8HxQ input:checked + .RemoveRoutes_checkboxFake__zPl4Y {
  background: #3f51b5;
  border-color: #3f51b5;
  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
}

.RemoveRoutes_checkboxFake__zPl4Y::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg) translate(0, -1px);
  opacity: 0;
  transition: opacity 0.2s ease;
  top: 4px;
  left: 3px;
}

.RemoveRoutes_checkboxWrap__Z8HxQ input:checked + .RemoveRoutes_checkboxFake__zPl4Y::after {
  opacity: 1;
}

/* инфо */
.RemoveRoutes_info__Wd0wu {
  margin-top: 4px;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
}

.RemoveRoutes_info__Wd0wu p {
  margin: 1px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* прогресс */
.RemoveRoutes_progress__g-qcG {
  margin-top: 8px;
}

.RemoveRoutes_bar__uen2d {
  display: flex;
  height: 5px;
  border-radius: 4px;
  overflow: hidden;
  background: #e0e0e0;
}

.RemoveRoutes_delivered__NRzf7 {
  background: #4caf50;
}

.RemoveRoutes_inProgress__SXDWH {
  background: #2196f3;
}

.RemoveRoutes_undelivered__IWUk\\+ {
  background: #f44336;
}

.RemoveRoutes_progressText__rAKLn {
  font-size: 12px;
  color: #444;
  text-align: right;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/RemoveRoutes/RemoveRoutes.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,WAAW;AACX;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,aAAa;AACb;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,4CAA4C;EAC5C,UAAU;EACV,6BAA6B;EAC7B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".controlsRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.bulkActions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* кнопки */\r\n.selectAllBtn,\r\n.deleteSelectedBtn {\r\n  border-radius: 8px;\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n  border: 1px solid #cbd3e1;\r\n  background: #f9fafc;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.selectAllBtn:hover:not(:disabled),\r\n.deleteSelectedBtn:hover:not(:disabled) {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.deleteSelectedBtn {\r\n  border-color: #e53935;\r\n  background: #e53935;\r\n  color: #fff;\r\n}\r\n\r\n.deleteSelectedBtn:hover:not(:disabled) {\r\n  background: #c62828;\r\n}\r\n\r\n.selectAllBtn:disabled,\r\n.deleteSelectedBtn:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n/* состояния */\r\n.stateText {\r\n  margin-top: 24px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n/* карточки */\r\n.cardsWrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\r\n  gap: 12px;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.card {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px 12px;\r\n  transition: all 0.2s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selected {\r\n  border: 2px solid #3f51b5;\r\n  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);\r\n}\r\n\r\n/* верхняя строка: заголовок + чекбокс */\r\n.topRow {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.header h3 {\r\n  margin: 0 0 4px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #222;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.dateLabel {\r\n  font-size: 12px;\r\n  color: #757575;\r\n}\r\n\r\n/* чекбокс */\r\n.checkboxWrap {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.checkboxWrap input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.checkboxFake {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 4px;\r\n  border: 1px solid #cbd3e1;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.checkboxWrap input:checked + .checkboxFake {\r\n  background: #3f51b5;\r\n  border-color: #3f51b5;\r\n  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);\r\n}\r\n\r\n.checkboxFake::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 10px;\r\n  height: 6px;\r\n  border-left: 2px solid #fff;\r\n  border-bottom: 2px solid #fff;\r\n  transform: rotate(-45deg) translate(0, -1px);\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  top: 4px;\r\n  left: 3px;\r\n}\r\n\r\n.checkboxWrap input:checked + .checkboxFake::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* инфо */\r\n.info {\r\n  margin-top: 4px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  line-height: 1.4;\r\n}\r\n\r\n.info p {\r\n  margin: 1px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n/* прогресс */\r\n.progress {\r\n  margin-top: 8px;\r\n}\r\n\r\n.bar {\r\n  display: flex;\r\n  height: 5px;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: #e0e0e0;\r\n}\r\n\r\n.delivered {\r\n  background: #4caf50;\r\n}\r\n\r\n.inProgress {\r\n  background: #2196f3;\r\n}\r\n\r\n.undelivered {\r\n  background: #f44336;\r\n}\r\n\r\n.progressText {\r\n  font-size: 12px;\r\n  color: #444;\r\n  text-align: right;\r\n  margin-top: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlsRow": `RemoveRoutes_controlsRow__7GBbW`,
	"bulkActions": `RemoveRoutes_bulkActions__dwHir`,
	"selectAllBtn": `RemoveRoutes_selectAllBtn__6Ua9l`,
	"deleteSelectedBtn": `RemoveRoutes_deleteSelectedBtn__2Kwlf`,
	"stateText": `RemoveRoutes_stateText__tyJ9F`,
	"cardsWrapper": `RemoveRoutes_cardsWrapper__VMgiI`,
	"card": `RemoveRoutes_card__zfM3I`,
	"selected": `RemoveRoutes_selected__ttwhb`,
	"topRow": `RemoveRoutes_topRow__dJC-+`,
	"header": `RemoveRoutes_header__q2ONo`,
	"dateLabel": `RemoveRoutes_dateLabel__patTs`,
	"checkboxWrap": `RemoveRoutes_checkboxWrap__Z8HxQ`,
	"checkboxFake": `RemoveRoutes_checkboxFake__zPl4Y`,
	"info": `RemoveRoutes_info__Wd0wu`,
	"progress": `RemoveRoutes_progress__g-qcG`,
	"bar": `RemoveRoutes_bar__uen2d`,
	"delivered": `RemoveRoutes_delivered__NRzf7`,
	"inProgress": `RemoveRoutes_inProgress__SXDWH`,
	"undelivered": `RemoveRoutes_undelivered__IWUk+`,
	"progressText": `RemoveRoutes_progressText__rAKLn`
};
export default ___CSS_LOADER_EXPORT___;
